import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { latestResources, categorySlug } from '../resources/resourceList';
import './NavigationMobile.css';
import shieldLogo from '../../assets/shield_logo.png';

const NavigationMobile = () => {
  const [onDark, setOnDark] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const navBottom = 60;
      let dark_ = false;
      const darkSections = document.querySelectorAll('.main-hero, .section-dark, .site-footer, .runtime-content, .rsm-content, .pt-content, .ptm-content, .ws-content, .wsm-content, .uc-content, .ucp-content');
      darkSections.forEach(el => {
        const r = el.getBoundingClientRect();
        if (r.top < navBottom && r.bottom > navBottom) dark_ = true;
      });
      if (dark_) {
        const lightSections = document.querySelectorAll('.runtime-section-light, .rsm-section-light, .pt-section-light, .ptm-section-light, .ws-section-light, .wsm-section-light, .ucp-section-light');
        lightSections.forEach(el => {
          const r = el.getBoundingClientRect();
          if (r.top < navBottom && r.bottom > navBottom) dark_ = false;
        });
      }
      setOnDark(dark_);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Lock body scroll when menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const go = (path) => {
    setMenuOpen(false);
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <nav className={`m-navigation ${onDark ? 'nav-dark' : 'nav-light'}`}>
        <div className="m-nav-container">
          <div className="m-nav-logo" onClick={() => go('/')} style={{ cursor: 'pointer' }}>
            <img src={shieldLogo} alt="Bltz AI" className="logo-icon" />
            <span className="logo-text">Bltz AI</span>
          </div>
          <button className="m-nav-hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
            <span className={`m-hamburger-bar ${menuOpen ? 'm-bar-open' : ''}`}></span>
            <span className={`m-hamburger-bar ${menuOpen ? 'm-bar-open' : ''}`}></span>
            <span className={`m-hamburger-bar ${menuOpen ? 'm-bar-open' : ''}`}></span>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="m-nav-overlay" onClick={() => setMenuOpen(false)}>
          <div className="m-nav-drawer" onClick={e => e.stopPropagation()}>
            <div className="m-nav-drawer-items">
              <span className="m-nav-drawer-item" onClick={() => go('/')}>Home</span>
              <span className="m-nav-drawer-label">Platform</span>
              <span className="m-nav-drawer-item m-nav-drawer-sub" onClick={() => { setMenuOpen(false); navigate('/runtime-shield'); setTimeout(() => { const el = document.getElementById('section-discovery'); if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' }); }, 300); }}>Visibility</span>
              <span className="m-nav-drawer-item m-nav-drawer-sub" onClick={() => go('/runtime-shield')}>Runtime Shield</span>
              <span className="m-nav-drawer-item m-nav-drawer-sub" onClick={() => go('/purple-team')}>Purple Team</span>
              <span className="m-nav-drawer-item m-nav-drawer-sub" onClick={() => go('/ai-governance')}>AI Governance</span>
              <span className="m-nav-drawer-label">Research</span>
              {latestResources.map((card) => (
                <span key={card.slug} className="m-nav-drawer-item m-nav-drawer-sub" onClick={() => go(`/resources/${card.slug}`)}>
                  <span className={`nav-cat-badge nav-cat-badge--${categorySlug(card.category)}`}>{card.category}</span>
                  {card.navTitle || card.title}
                </span>
              ))}
              <span className="m-nav-drawer-item m-nav-drawer-sub" onClick={() => go('/resources')}>View All Research</span>
              <span className="m-nav-drawer-label">Use Cases</span>
              <span className="m-nav-drawer-item m-nav-drawer-sub" onClick={() => go('/use-cases/banking')}>Banking & Financial Services</span>
              <span className="m-nav-drawer-item m-nav-drawer-sub" onClick={() => go('/use-cases/legal')}>Legal Services</span>
              <span className="m-nav-drawer-item m-nav-drawer-sub" onClick={() => go('/use-cases/medical')}>Medical & Healthcare</span>
              <span className="m-nav-drawer-item m-nav-drawer-sub" onClick={() => go('/use-cases/hospitality')}>Hospitality & Travel</span>
              <span className="m-nav-drawer-item m-nav-drawer-sub" onClick={() => go('/use-cases')}>View All Use Cases</span>
              <span className="m-nav-drawer-item m-nav-drawer-link" onClick={() => go('/partner')}>Partners</span>
              <span className="m-nav-drawer-item m-nav-drawer-link" onClick={() => go('/contact')}>Contact Us</span>
              <button className="m-nav-drawer-demo" onClick={() => go('/book-demo')}>Book a Demo</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NavigationMobile;
